import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import { popupTypes } from 'helpers/constants';
import { LoadingStatusWrapper } from 'sharedComponents/WithLoadingStatus';

import './styles.scss';

const ConvertToLocationModal = ({
    show,
    onClose,
    onConfirm,
    powertrainName,
    isLoading
}) => {
    const { t: translate } = useTranslation();

    return (
        <GeneralDialog
            show={show}
            close={onClose}
            title={translate('ABB.Powertrain.Frontend.convertToLocationModalTitle')}
            modalClassName='convert-to-location-modal'
            notificationType={popupTypes.INFO}
            cancelButtonProps={{
                text: translate('ABB.Powertrain.Frontend.cancelLabel'),
                onClick: onClose,
                disabled: isLoading
            }}
            acceptButtonProps={{
                text: translate('ABB.Powertrain.Frontend.convertLabel'),
                onClick: onConfirm,
                disabled: isLoading
            }}
            closeButton={!isLoading}
            persistent={isLoading}
        >
            <LoadingStatusWrapper
                useCustomAnchor
                loadingStatus={isLoading ? 'loading' : 'success'}
            >
                <div className='convert-to-location-modal__content'>
                    <p
                        className='convert-to-location-modal__text'
                        dangerouslySetInnerHTML={{
                            __html: translate('ABB.Powertrain.Frontend.convertToLocationModalDescription', { powertrainName })
                        }}
                    />
                    <p className='convert-to-location-modal__warning'>
                        {translate('ABB.Powertrain.Frontend.convertToLocationModalWarning')}
                    </p>
                </div>
            </LoadingStatusWrapper>
        </GeneralDialog>
    );
};

ConvertToLocationModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    powertrainName: PropTypes.string,
    isLoading: PropTypes.bool
};

ConvertToLocationModal.defaultProps = {
    isLoading: false
};

export default ConvertToLocationModal;
